/*-------------------------Actual APIs-------------------------*/
const local = true;
const scope_url = process.env.REACT_APP_SCOPE_URL;
const backendApi = process.env.REACT_APP_BACKEND_API;
const clientId = process.env.REACT_APP_CLIENT_ID;
const redirect_Uri = process.env.REACT_APP_REDIRECT_URI;
const group_id = process.env.REACT_APP_GROUP_ID;
const authorizationEndpoint = process.env.REACT_APP_AUTHORIZATION_ENDPOINT;
const authUrl = `${backendApi}/isauthenticated`;
const userInfoUrl = `${backendApi}/userinfo?post_sign_in_url=https%3A%2F%2F`;
const authoriseUrl = `${backendApi}/isauthorised?post_sign_in_url=https%3A%2F%2F`;
const demoAppUrl = `${backendApi}/demoApp`;
const masterAppUrl = `/master/demoApp`;
const api_url = `${backendApi}/harbor`;
const userListUrl = `${backendApi}/users?app_handle=scenario_builder`;
const api_db_url = backendApi;

const header = [
  { label: "Feature Selection", mandatory: true, help: true },
  { label: "Calculation Type ", mandatory: true, help: true },
  { label: "Calculation Value", mandatory: true, help: false },
  { label: "Value As of Date", mandatory: false, help: false },
  { label: "From Date", mandatory: true, help: false },
  { label: "End Date", mandatory: false, help: false },
  { label: "", mandatory: false, help: false },
];
const feature_header = [
  "Feature Name",
  "Feature Type",
  "Minimum Value",
  "Maximum Value",
];

//scenario share options
const shareOptions = [
  { label: "View", value: "view" },
  { label: "View & Run", value: "view&run" },
  { label: "Edit & Run", value: "edit&run" },
];

//Download optons for view runs
let download_options = [
  { label: "Output Files", value: "output" },
  { label: "Intermediate Files", value: "intermediate" },
];

const messages = {
  workInProgressMessage: "Your content here.",
  authenticatingUserMessage: "Authenticating user",
  loginPrimaryText: "Log in to find out more!",
  clusterMessage: "Cluster is starting. Please Wait!",
  UnauthorisedMessage:
    "You don't have access to this app. Please contact support for the access.",
  scenario_saved: "Scenario Saved Successfully",
  scenario_save_run: "Scenario Saved Successfully",
  scenario_run_completed: "Scenario Run Completeted Successfully",
  scenario_run_failed: "Failed",
  scenario_run_triggered: "Scenario Run Triggered",
  scenario_fill_all: "Please Fill all the Mandatory Details",
  scenario_row_fill: "Please fill all mandatory details in the current row",
  scenario_continuous_check: "Please Provide value in the range of 1-100",
  scenario_percenatage_check: "Please Provide value in the range of 1-10000",
  scenario_boolean_check: "Please Provide value in the range of 0-1",
  scenario_discrete_check: "Please Provide value in the range of 0-7",
  scenario_index_check: "Please Provide value in the range of 1-100",
  scenario_max_features: "Maximum number of features selected",
  scenario_copy: "Scenario Copied Successfully",
  scenario_delete: "Scenario Deleted Successfully",
  scenario_share: "Scenario shared with selected users successfully",
  scenario_star: "Scenario Starred Successfully",
  scenario_unstar: "Scenario Removed from Starred Scenario",
  run_deleted: "Scenario Run Deleted Successfully",
  scenario_access: "Please choose the  access for all the users",
  scenario_share_delete: "Scenario shared deleted successfully",
  view_run_error: "Failed to Fetch Run Data",
  special_character:
    "Scenario name should contain alphanumeric, whitespaces & these special characters '_' & '-'.",
  scenario_share_user: "Please select atleast one user",
  scenario_multi_step:
    " Multi step feature - please provide End Date at the following table row : ",
  scenario_date_adjust:
    "Selected date have been adjusted to the nearest weekday",
  scenario_max_asof: "Please choose date within the max date",
  scenario_feature_range: "Please select value in the range of",
  timeout: 5000,
  unexpected_error: "Unexpected error occured please try again...",
};

const weeks = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 0,
};
const add_scenario = {
  header,
  feature_header,
  weeks,
};
const my_scenario = {
  shareOptions,
};
const view_runs = {
  download_options,
  viewRunPanels: ["All", "Currently Running", "Queued", "Previous Runs"],
  timeout: 300000,
};
const table_rows = {
  pagination_size: 5,
};
const notifications = {
  timeout: 300000,
};

const hardCoded = {
  homeLocation: "https://data.reckitt.com/",
  appName: "Harbor App",
  sbAppId: "scenario_builder",
};

const admin_user_header = ["Username", "Email", "Created By", "Actions"];
const api = {
  clientId,
  scope_url,
  redirect_Uri,
  authorizationEndpoint,
  authUrl,
  group_id,
  userInfoUrl,
  demoAppUrl,
  masterAppUrl,
  authoriseUrl,
  api_url,
  userListUrl,
  api_db_url,
  local,
};

const config = {
  footerText: "Powered by Harbor",
  api,
  messages,
  hardCoded,
  add_scenario,
  my_scenario,
  view_runs,
  table_rows,
  notifications,
  admin_user_header,
};

export { config };
